/** Temporary CRD-1185 hub investigation — remove after root cause is fixed. */
export interface ReportingDebugEntry {
  ts: number;
  kind: 'api' | 'spec' | 'widget-mount';
  widgetId?: string;
  path?: string;
  message: string;
  status?: number;
  request?: unknown;
}

const STORAGE_KEY = 'eh.reporting.debug';

export function reportingDebugEnabled(): boolean {
  try {
    // Opt in only: a diagnostic sink has no business running for every
    // production user by default.
    return sessionStorage.getItem('eh-reporting-debug') === '1';
  } catch {
    return false;
  }
}

export function pushReportingDebug(
  entry: Omit<ReportingDebugEntry, 'ts'>
): void {
  const payload: ReportingDebugEntry = { ts: Date.now(), ...entry };
  console.error('[CRD-1185-reporting-debug]', payload);
  try {
    const prev = JSON.parse(
      sessionStorage.getItem(STORAGE_KEY) ?? '[]'
    ) as ReportingDebugEntry[];
    prev.push(payload);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(prev.slice(-80)));
  } catch {
    // sessionStorage may be unavailable during SSR/tests.
  }
}

export function readReportingDebug(): ReportingDebugEntry[] {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? '[]');
  } catch {
    return [];
  }
}
